import { ApiExtraModels, ApiProperty, getSchemaPath } from '@nestjs/swagger';

export class PaginationMetaDto {
  @ApiProperty()
  total!: number;

  @ApiProperty()
  page!: number;

  @ApiProperty()
  pageSize!: number;

  @ApiProperty()
  pages!: number;
}

// Generic helper to build a paginated DTO with Swagger metadata
export const createPaginatedDto = <T extends new (...args: any[]) => any>(
  ItemDto: T,
) => {
  @ApiExtraModels(ItemDto)
  class PaginatedDto {
    @ApiProperty({
      type: 'array',
      items: { $ref: getSchemaPath(ItemDto) },
    })
    items!: InstanceType<T>[];

    @ApiProperty()
    total!: number;

    @ApiProperty()
    page!: number;

    @ApiProperty()
    pageSize!: number;

    @ApiProperty()
    pages!: number;
  }

  return PaginatedDto;
};
